import type { RouteRecordRaw } from 'vue-router'
import { investorRoutes } from './investors/routes'

export const routes: RouteRecordRaw[] = [
    {
        name: 'home',
        path: '/',
        component: () => import('./index.vue'),
    },
    ...investorRoutes,
    {
        name: 'notFound',
        path: '/:pathMatch(.*)*',
        component: () => import('./not-found.vue'),
    },
]
